import { Box, Typography, CircularProgress } from '@mui/material';
import { SentimentDissatisfied, ErrorOutline, FolderOpen } from '@mui/icons-material';

export default function EmptyState({ type = 'loading', message }) {
  if (type === 'loading') {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          py: 8,
          gap: 2
        }}
      >
        <CircularProgress size={48} thickness={4} />
        <Typography variant="body1" color="text.secondary" sx={{ fontWeight: 500 }}>
          {message || 'Loading episodes...'}
        </Typography>
        <Typography variant="caption" color="text.disabled">
          Just a moment
        </Typography>
      </Box>
    );
  }

  if (type === 'error') {
    return (
      <Box sx={{ py: 8, textAlign: 'center' }}>
        <ErrorOutline
          sx={{
            fontSize: 64,
            color: 'error.main',
            opacity: 0.8,
            mb: 2
          }}
        />
        <Typography variant="h6" color="error" gutterBottom fontWeight={600}>
          Oops! Something went wrong
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          {message || 'We couldn\'t load the content. Please try again later.'}
        </Typography>
        <Typography variant="caption" color="text.disabled">
          If this keeps happening, please check your connection
        </Typography>
      </Box>
    );
  }

  if (type === 'empty') {
    return (
      <Box sx={{ py: 8, textAlign: 'center' }}>
        <FolderOpen
          sx={{
            fontSize: 64,
            color: 'text.disabled',
            opacity: 0.5,
            mb: 2
          }}
        />
        <Typography variant="h6" color="text.secondary" gutterBottom fontWeight={600}>
          Nothing here yet
        </Typography>
        <Typography variant="body2" color="text.disabled">
          {message || 'No items found.'}
        </Typography>
      </Box>
    );
  }

  if (type === 'no-results') {
    return (
      <Box sx={{ py: 8, textAlign: 'center' }}>
        <SentimentDissatisfied
          sx={{
            fontSize: 64,
            color: 'text.disabled',
            opacity: 0.5,
            mb: 2
          }}
        />
        <Typography variant="h6" color="text.secondary" gutterBottom fontWeight={600}>
          No results found
        </Typography>
        <Typography variant="body2" color="text.disabled">
          {message || 'Try adjusting your search or filters.'}
        </Typography>
      </Box>
    );
  }

  return null;
}
